import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-ink">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
